import React, { useState } from 'react';
import Styled from 'styled-components';
import Row from '../components/Row';
import CloseIcon from 'mdi-react/CloseIcon';

export default function TopBar({
  show = false,
  type = 'warning',
  message,
  clickableText,
  showClose,
  time,
  onClose = () => {}
}) {
  const handleOnClick = () => {
    alert('Clicked');
  };

  const getTime = () => {
    if (time) {
      setTimeout(() => {
        onClose();
      }, 5000);
    }
  };

  if (show) {
    return (
      <TopBarContainer type={type}>
        <Row justify="space-between">
          <span style={{ color: 'white', textAlign: 'center', width: '100%' }}>
            {message}
            {clickableText ? (
              <span
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => handleOnClick()}
              >
                {clickableText}
              </span>
            ) : (
              ''
            )}
          </span>
          {showClose ? (
            <CloseIcon
              style={{ cursor: 'pointer' }}
              onClick={onClose}
              color="white"
            />
          ) : null}
          {getTime()}
        </Row>
      </TopBarContainer>
    );
  }
  return null;
}

export function useTopBar(state = false) {
  const [show, setShow] = useState(state);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');
  const [showClose, setShowClose] = useState('');
  const [clickableText, setClickableText] = useState('');
  const [time, setTime] = useState(false);

  return {
    props: {
      show: show,
      type: type,
      message,
      clickableText,
      showClose,
      onClose: () => setShow(false),
      time
    },
    show: (type, message, clickableText, showClose, time) => {
      setShow(true);
      setMessage(message);
      setType(type);
      setShowClose(showClose);
      setClickableText(clickableText);
      setTime(time);
    },
    close: () => setShow(false)
  };
}

const TopBarContainer = Styled.div`
  padding: 4px;
  display:flex;
  background-color: ${props =>
    props.type === 'warning'
      ? '#ffbf00'
      : props.type === 'error'
      ? '#f44336'
      : props.type === 'success'
      ? 'green'
      : '#008080'}
`;
